import { render } from "./FormButtons.vue?vue&type=template&id=8f0cc686&scoped=true"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"

import "./FormButtons.vue?vue&type=style&index=0&id=8f0cc686&scoped=true&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0cc686"]])

export default __exports__